import React, { useEffect, useRef, useState } from 'react'
import FlexComponent from '../FlexComponent'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { ErrorMessage, Field } from 'formik'
import './form.css'
import { Dropdown } from 'primereact/dropdown'
import { InputMask } from 'primereact/inputmask'
import { OverlayPanel } from 'primereact/overlaypanel'
import axios from '../../utils/axios'
import { useSelector } from 'react-redux'
import { syncWithPhoneApp, sendMessage } from '../../utils/urls'

function ShortFormComponent({ setLanguageSelect, values, ghlUserId, locationData, errors, touched, handleBlur, handleChange, setFieldValue, toast }) {
    const [userOptions, setUserOptions] = useState([]);
    const [ghlUserName, setGhlUserName] = useState(null)
    const [syncLoading, setSyncLoading] = useState(false)
    const sendOp = useRef(null)
    const [sendContactId, setSendContactId] = useState('')
    const [sendMessageLoading, setSendMessageLoading] = useState('')
    const userId = useSelector((state) => state.user.userId)
    const bizCardUrl = useSelector((state) => state.user.bizCardUrl)
    const locationCardUrl = useSelector((state) => state.user.locationCardUrl)
    const isSuperuser = useSelector((state) => state.user.isSuperuser);

    const handleSendMessage = async (tag, language, locationId) => {
        if (!sendContactId.trim()) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please enter a Contact ID', life: 2000 });
            return;
        }
        if (!locationId) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please select a location first', life: 2000 });
            return;
        }
        setSendMessageLoading(tag);
        try {
            const response = await axios.post(sendMessage, {
                locationId,
                contactId: sendContactId.trim(),
                userId,
                language,
                tag,
            }, { headers: { 'Content-Type': 'application/json' } });
            if (response.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: response.data?.message || 'Sent successfully', life: 3000 });
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
        } finally {
            setSendMessageLoading('');
        }
    };
    const activePipeline = useSelector((state) => state.user.activePipeline === "null" ? "" : state.user.activePipeline);
    const appPipeline = useSelector((state) => state.user.appPipeline === "null" ? "" : state.user.appPipeline);
    const defaultLanguage = useSelector((state) => state.user.defaultLanguage === "null" ? "" : state.user.defaultLanguage);

    useEffect(() => {
        if (activePipeline && !values.which_homes_for_sale_region) {
            setFieldValue("which_homes_for_sale_region", activePipeline)
        }
        // console.log("appPipeline", appPipeline);

        if (appPipeline && !values.application_pipeline) {
            setFieldValue("application_pipeline", appPipeline)
        }

        if (defaultLanguage && !values.language) {
            if(defaultLanguage.includes("English") && defaultLanguage.includes("Spanish")){
                setFieldValue("language", "Spanish & Some English")
            }else if(defaultLanguage.includes("English")){
                setFieldValue("language", "English")
            }else if(defaultLanguage.includes("Other")){
                setFieldValue("language", "Other")
            }
        }
    }, [activePipeline, appPipeline, defaultLanguage ])


    useEffect(() => {
        if (ghlUserId) {
            handleChange('application_by')(ghlUserId)
            setGhlUserName(findFullNameById(ghlUserId))
        }
        const selectedLocation = values.which_homes_for_sale_region;
        const selectedLocationData = locationData?.find((location) => location.location_id === selectedLocation);
        const options = selectedLocationData?.users?.map((user) => ({
            label: user.full_name || user.name,
            value: user.user_id,
        })) || [];
        setUserOptions(options);
    }, [locationData, values.which_homes_for_sale_region, ghlUserId]);

    const findFullNameById = (userId) => {
        if (locationData) {
            for (let location of locationData) {
                for (let user of location.users) {
                    if (user.user_id === userId) {
                        return user.full_name;
                    }
                }
            }
        }
        return null;
    };

    const leadDetailsOnclick = async () => {
        try {
            setSyncLoading(true)
            const cleaned = values.cell_phone_number.replace(/\D/g, '');
            const formattedNo = `+1${cleaned}`;
            let data = {
                email: values.email,
                phone: cleaned ? formattedNo : ""
            }
            const response = await axios.post(syncWithPhoneApp, data, {
                headers: { 'Content-Type': 'application/json' },
            });
            if (response.status === 200) {
                let data = response.data
                console.log("data", data);

                setFieldValue("firstName", data.first_name)
                setFieldValue("middleName", data.middle_name)
                setFieldValue("lastName", data.last_name)
                setFieldValue("lead_source", data.source)
                setFieldValue("prospecting_account", data.location_name)
                if (data.phone) {
                    const phone = data.phone;
                    const formatted = phone.replace("+1", "").replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
                    console.log("formatted", formatted);
                    setFieldValue("cell_phone_number", formatted)
                }

                setFieldValue("email", data.email)
                setFieldValue("language", data.language)
                // setFieldValue("which_homes_for_sale_region", data.location_id)
                if (data.contact_id) setSendContactId(data.contact_id)
                setSyncLoading(false)
            }
        } catch (error) {
            setSyncLoading(false)
            toast.current.show({ severity: 'error', summary: '', detail: error?.response?.data?.error, life: 2000 });
        }
    }

    return (
        <div style={{ width: '100%', padding: '0.5rem 0 0 5.8%' }} id='getStarted'>

            <FlexComponent alignItems="center" justifyContent="space-between" style={{ flexWrap: 'wrap', gap: '0.5rem' }}>
                <p style={{ fontSize: '28px', fontWeight: 'bold', padding: '0.75rem', color: 'black' }}>I can definitely help. Let's get started!</p>
                <div style={{ padding: '0 1rem' }}>
                    <FlexComponent gap=".4rem" alignItems="center">
                        <InputText
                            value={sendContactId}
                            onChange={(e) => setSendContactId(e.target.value)}
                            placeholder="GHL Contact ID"
                            style={{ flex: 1, fontSize: '12px' }}
                        />
                        <Button
                            type="button"
                            label="Send"
                            style={{ background: 'black', fontSize: '12px', whiteSpace: 'nowrap' }}
                            disabled={!sendContactId.trim()}
                            onClick={(e) => sendOp.current.toggle(e)}
                        />
                    </FlexComponent>
                    <OverlayPanel ref={sendOp}>
                        <FlexComponent flexDirection="column" gap=".4rem" alignItems="start">
                            {bizCardUrl && (
                                <Button
                                    type="button"
                                    label="Send Biz Card"
                                    style={{ width: '100%', fontSize: '12px', background: 'black' }}
                                    loading={sendMessageLoading === 'send-bizcard'}
                                    onClick={() => { sendOp.current.hide(); handleSendMessage('send-bizcard', values.language, values.which_homes_for_sale_region); }}
                                />
                            )}
                            {locationCardUrl && (
                                <Button
                                    type="button"
                                    label="Send Location Graphic"
                                    style={{ width: '100%', fontSize: '12px', background: 'black' }}
                                    loading={sendMessageLoading === 'send location graphic'}
                                    onClick={() => { sendOp.current.hide(); handleSendMessage('send location graphic', values.language, values.which_homes_for_sale_region); }}
                                />
                            )}
                            <Button
                                type="button"
                                label="Send Spanish Document List"
                                style={{ width: '100%', fontSize: '12px', background: 'black' }}
                                loading={sendMessageLoading === 'send spanish document list'}
                                onClick={() => { sendOp.current.hide(); handleSendMessage('send spanish document list', 'spanish', values.which_homes_for_sale_region); }}
                            />
                            <Button
                                type="button"
                                label="Send English Document List"
                                style={{ width: '100%', fontSize: '12px', background: 'black' }}
                                loading={sendMessageLoading === 'send english document list'}
                                onClick={() => { sendOp.current.hide(); handleSendMessage('send english document list', 'english', values.which_homes_for_sale_region); }}
                            />
                        </FlexComponent>
                    </OverlayPanel>
                </div>
            </FlexComponent>

            <FlexComponent className='inputFlexContainer' gap='1rem' alignItems='start' style={{ padding: "1rem 0" }}>
                <div className='inputContainerDiv' style={{ textAlign: 'start', width: '100%', margin: '0.5rem' }}>
                    <FlexComponent className='inputFlexContainer' gap='1rem' alignItems='start'>
                        <div className='inputContainerDiv' style={{ width: '15%' }}>
                            <Field type="text" id="firstName" placeholder="First Name *" name="firstName" className={Boolean((touched.firstName && errors.firstName)) && "fieldErrorShow"} as={InputText} style={{ width: '100%' }} onBlur={handleBlur} />
                        </div>
                        <div className='inputContainerDiv' style={{ width: '15%' }}>
                            <Field type="text" id="middleName" placeholder="Middle Name" name="middleName" as={InputText} style={{ width: '100%' }} onBlur={handleBlur} />
                        </div>
                        <div className='inputContainerDiv' style={{ width: '15%' }}>
                            <Field type="text" id="lastName" placeholder="Last Name *" name="lastName" className={Boolean((touched.lastName && errors.lastName)) && "fieldErrorShow"} as={InputText} style={{ width: '100%' }} onBlur={handleBlur} />
                        </div>
                        <div className='inputContainerDiv' style={{ textAlign: 'start', width: '20%' }}>
                            <Dropdown
                                id='language'
                                value={values.language}
                                options={[
                                    { label: 'English', value: 'English' },
                                    { label: 'Spanish', value: 'Spanish' },
                                    { label: 'Spanish & Some English', value: 'Spanish & Some English' },
                                    { label: 'Other', value: 'Other' }
                                ]}
                                style={{ width: '100%' }}
                                className={Boolean((touched.language && errors.language)) && "fieldErrorShow"}
                                onChange={(e) => {
                                    handleChange({
                                        target: {
                                            name: `language`,
                                            value: e.value
                                        }
                                    })
                                    setLanguageSelect(e.value)
                                }}
                                showClear={values.language}
                                onBlur={handleBlur}
                                placeholder='Select Language *'
                            />
                            {values.language === 'Other' && (
                                <div style={{ marginTop: '1.1rem' }}>
                                    <Field type="text" placeholder="Other" id="otherLanguage" name="otherLanguage" as={InputText} style={{ width: '100%' }} onBlur={handleBlur} />
                                </div>
                            )}
                        </div>
                        <div className='inputContainerDiv' style={{ textAlign: 'start', width: '30%' }}>
                            <Dropdown
                                id='entry_type'
                                value={values.entry_type}
                                options={[
                                    { label: 'Renter', value: 'Renter' },
                                    { label: 'Listing Lead', value: 'Listing Lead' },
                                    { label: 'Already Preapproved Buyer Lead!', value: 'Already Preapproved Buyer Lead!' },
                                    { label: 'New Loan Set Up', value: 'New Loan Set Up' },
                                    { label: 'Cash buyer', value: 'Cash buyer' },
                                    { label: 'New App (quick entry)', value: 'New App (quick entry)' }
                                ]}
                                style={{ width: '100%' }}
                                className={Boolean((touched.entry_type && errors.entry_type)) && "fieldErrorShow"}
                                onChange={(e) => handleChange({
                                    target: {
                                        name: `entry_type`,
                                        value: e.value
                                    }
                                })}
                                showClear={values.entry_type}
                                onBlur={handleBlur}
                                placeholder='Select Entry Type *'
                            />
                        </div>
                    </FlexComponent>

                    <FlexComponent className='inputFlexContainer' justifyContent="start" gap='1rem' alignItems='start'>
                        <div className='inputContainerDiv' style={{ marginTop: '1.2rem', width: '20%' }}>
                            <div className={`p-inputgroup flex-1 login-input-div`} style={{ borderRadius: "5px", border: Boolean((touched.cell_phone_number && errors.cell_phone_number)) ? "1px solid red" : "" }}>
                                <span className="p-inputgroup-addon" style={{ borderRight: "none" }}>
                                    <i className='pi pi-mobile' style={{ color: "black", fontWeight: "bold", padding: "5px", borderRadius: "30px" }}></i>
                                </span>
                                <InputMask
                                    mask="(999) 999-9999"
                                    className='inputWithIcon'
                                    type="text"
                                    id="cell_phone_number"
                                    name="cell_phone_number"
                                    value={values.cell_phone_number || null}
                                    onChange={handleChange}
                                    style={{ width: '100%', borderLeft: "none" }}
                                    onBlur={handleBlur}
                                />
                            </div>
                        </div>

                        <div className='inputContainerDiv' style={{ marginTop: '1.2rem', width: '16%' }}>
                            <Button disabled={!values.email && !values.cell_phone_number} onClick={() => {
                                leadDetailsOnclick()
                            }} type='button' loading={syncLoading} icon="pi pi-sync" label='Sync With Phone App' style={{ fontSize: "12px", padding: ".83rem .75rem" }} />
                        </div>
                        <div className='inputContainerDiv' style={{ marginTop: '1.2rem', width: '20%' }}>
                            <div className={`p-inputgroup flex-1 login-input-div`} style={{ borderRadius: "5px" }}>
                                <span className="p-inputgroup-addon" style={{ borderRight: "none" }}>
                                    <i className='pi pi-envelope' style={{ color: "black", fontWeight: "bold", padding: "5px", borderRadius: "30px" }}></i>
                                </span>
                                <Field type="text" id="email" className='inputWithIcon' placeholder="Email" name="email" as={InputText} style={{ width: '100%', borderLeft: "none" }} onBlur={handleBlur} />
                            </div>
                        </div>
                        <div className='inputContainerDiv' style={{ textAlign: 'start', marginTop: '1.2rem', width: '25%' }}>
                            <Dropdown
                                id='lead_source'
                                value={values.lead_source}
                                options={[
                                    { label: "Homes For Sale Lead", value: "Homes For Sale Lead" },
                                    { label: "Lead Derived Referral", value: "Lead Derived Referral" },
                                    { label: "Lead Derived Referral Source", value: "Lead Derived Referral Source" },
                                    { label: "Self Sourced", value: "Self Sourced" },
                                    { label: "Home Help Lead", value: "Home Help Lead" },
                                    { label: "Other", value: "Other" }
                                ]}
                                style={{ width: '100%' }}
                                className={Boolean((touched.lead_source && errors.lead_source)) && "fieldErrorShow"}
                                onChange={(e) => {
                                    handleChange({
                                        target: {
                                            name: `lead_source`,
                                            value: e.value
                                        }
                                    })
                                }}
                                showClear={values.lead_source}
                                onBlur={handleBlur}
                                placeholder='Source *'
                            />
                            {values.lead_source === 'Other' && (
                                <div style={{ marginTop: '1.1rem' }}>
                                    <Field type="text" placeholder="Other" id="other_lead_source" name="other_lead_source" as={InputText} style={{ width: '100%' }} onBlur={handleBlur} />
                                </div>
                            )}
                        </div>
                    </FlexComponent>

                    <FlexComponent className='inputFlexContainer' gap='1rem' alignItems='start' justifyContent="start">
                        <div className='inputContainerDiv' style={{ textAlign: 'start', marginTop: '1.2rem', width: '25%' }}>
                            <Dropdown
                                id='which_homes_for_sale_region'
                                value={values.which_homes_for_sale_region || activePipeline}
                                options={locationData?.map((location) => ({
                                    label: location.location_name,
                                    value: location.location_id,
                                })) || []}
                                style={{ width: '100%' }}
                                className={Boolean((touched.which_homes_for_sale_region && errors.which_homes_for_sale_region)) && "fieldErrorShow"}
                                onChange={(e) => {
                                    handleChange({
                                        target: {
                                            name: `which_homes_for_sale_region`,
                                            value: e.value
                                        }
                                    })
                                    setFieldValue("application_pipeline", "")
                                }
                                }
                                showClear={values.which_homes_for_sale_region}
                                onBlur={handleBlur}
                                placeholder='Active Pipeline *'
                                filter
                            />
                        </div>
                        <div className='inputContainerDiv' style={{ marginTop: '1.2rem', width: '25%' }}>
                            <Dropdown
                                id='application_pipeline'
                                value={values.application_pipeline}
                                options={userOptions}
                                style={{ width: '100%' }}
                                className={Boolean((touched.application_pipeline && errors.application_pipeline)) && "fieldErrorShow"}
                                onChange={(e) => handleChange({
                                    target: {
                                        name: `application_pipeline`,
                                        value: e.value
                                    }
                                })}
                                showClear={values.application_pipeline}
                                onBlur={handleBlur}
                                placeholder='Application Pipeline *'
                                filter
                            />
                        </div>
                        <div className='inputContainerDiv' style={{ marginTop: '1.2rem', width: '25%' }}>
                            {ghlUserId ?
                                <InputText disabled value={ghlUserName} style={{ width: '100%' }} />
                                :
                                <Dropdown
                                    id='application_by'
                                    value={values.application_by}
                                    options={userOptions}
                                    style={{ width: '100%' }}
                                    className={Boolean((touched.application_by && errors.application_by)) && "fieldErrorShow"}
                                    onChange={(e) => handleChange({
                                        target: {
                                            name: `application_by`,
                                            value: e.value
                                        }
                                    })}
                                    showClear={values.application_by}
                                    onBlur={handleBlur}
                                    placeholder='Application By *'
                                    filter
                                />
                            }
                        </div>
                    </FlexComponent>
                </div>
            </FlexComponent>
        </div>
    )
}

export default ShortFormComponent